import React from 'react';
import { Col, Row } from 'react-bootstrap';
import NPPanel from '../../../NPPanel';
import * as Grants from '../../.././util/grants';
import { hasGrant } from '../../.././util/grantHelper';
import LogisticsDataTable from '../LogisticsDataTable';

class LogisticsData extends React.Component {
    constructor(props) {
        super(props);

        this.onSelectRow = this.onSelectRow.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.logisticsDataRefreshCounter = this.logisticsDataRefreshCounter.bind(this);

        this.state = {
            showModal: false,
            selectedRow: null,
            refreshCounter: 0
        };
    }

    onSelectRow(row) {
        this.setState({
            showModal: true,
            selectedRow: row,
        });
    }

    hideModal(saved) {
        this.setState({
            showModal: false,
        });
    }

    logisticsDataRefreshCounter() {
        this.setState({ refreshCounter: this.state.refreshCounter + 1 });
    }

    render() {
        const { apiToken, callOff } = this.props;

        return (<NPPanel>
            <Row>
                <Col sm={12}>
                    <LogisticsDataTable apiToken={apiToken} callOffFunctions={this.props.callOffFunctions} onSelectRow={this.onSelectRow} refreshCounter={this.state.refreshCounter} />
                </Col>
            </Row>
        </NPPanel>)
    }
}



export default LogisticsData;
